import { useMemo as o } from "react";
import { getOwnerDocument as t, getRootNode as r } from '../utils/owner.js';
function u() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return o(() => t(...e), [...e]);
}
function c() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  return o(() => r(...e), [...e]);
}
export { u as useOwnerDocument, c as useRootDocument };